import React from 'react'
import { connect } from 'react-redux'
import PropTypes from 'prop-types'
import moment from 'moment'

import {
  fetchHomepageIfNeeded,
  fetchCalendarIfNeeded,
  fetchCalendarExportIfNeeded,
  setSelectedSidebarNav,
  logout
} from '../../actions'
import {
  makeCalendarSelector,
  makeCalendarExportSelector
} from '../../selectors'

import CalendarComponent from '../../components/calendar/CalendarComponent'
import SidebarComponent from '../../components/sidebar/SidebarComponent'
import Profile from '../../classes/profile'
import { LS_HOMEPAGE_KEY } from '../../constants/local_storage'
import GoogleAnalytics from '../../classes/GoogleAnalytics'
import { CALENDAR_MODULE } from '../../constants/commons'

class CalendarContainer extends React.Component {
  static propTypes = {
    isAdmin: PropTypes.bool.isRequired,
    profile: Profile.PropTypes,
    history: PropTypes.object,
    match: PropTypes.object,
    homepage: PropTypes.object,
    logout: PropTypes.func.isRequired,
    location: PropTypes.object.isRequired,
    calendar: PropTypes.object.isRequired,
    calendarExport: PropTypes.shape({
      isFetching: PropTypes.bool.isRequired,
      error: PropTypes.object
    }).isRequired,
    fetchHomepage: PropTypes.func.isRequired,
    fetchCalendar: PropTypes.func.isRequired,
    fetchCalendarExport: PropTypes.func.isRequired,
    selectedNav: PropTypes.string,
    isContentIntelligence: PropTypes.bool,
    isCatalogAnalysis: PropTypes.bool,
    isPerformanceAnalysis: PropTypes.bool,
    isAIInsights: PropTypes.bool,
    selectedSidebarNav: PropTypes.func,
    shortcut: PropTypes.shape({
      id: PropTypes.string.isRequired,
      expires_at: PropTypes.string.isRequired,
      target: PropTypes.string.isRequired,
      target_id: PropTypes.string
    }),
    setShortcutPreference: PropTypes.func,
    shortcutPreference: PropTypes.string
  }

  componentDidMount () {
    GoogleAnalytics.trackGA(CALENDAR_MODULE, this.props.location, this.props.profile)
    const startDate = moment(new Date()).subtract(1, 'months').format('YYYY-MM-DD')
    const endDate = moment(new Date()).subtract(-2, 'months').format('YYYY-MM-DD')
    const homepage = JSON.parse(localStorage.getItem(LS_HOMEPAGE_KEY))
    if (!homepage) {
      if (this.props.profile && this.props.profile.groups.length > 0) {
        const groups = this.props.profile.groups
        const groupName = groups.filter(group => group !== 'Admin')[0]
        this.props.fetchHomepage(groupName)
      }
    }
    this.props.fetchCalendar(startDate, endDate)
  }

  render () {
    const { profile, history, location, calendar, fetchCalendarExport, selectedNav, isContentIntelligence, isCatalogAnalysis, isPerformanceAnalysis, isAIInsights, calendarExport, shortcut } = this.props
    const homepage = JSON.parse(localStorage.getItem(LS_HOMEPAGE_KEY))
    const myLogout = () => this.props.logout()
    return (
      <>
        <SidebarComponent
          isAdmin={this.props.isAdmin}
          profile={profile}
          logout={myLogout}
          location={location}
          shortcut={shortcut}
          homepage={homepage ? homepage : this.props.homepage}
          selectedSidebarNav={this.props.selectedSidebarNav}
          shortcutPreference={this.props.shortcutPreference}
          setShortcutPreference={this.props.setShortcutPreference}
          selectedNav={selectedNav}
          isContentIntelligence={isContentIntelligence}
          isCatalogAnalysis={isCatalogAnalysis}
          isPerformanceAnalysis={isPerformanceAnalysis}
          isAIInsights={isAIInsights}
        />
        <CalendarComponent
          calendar={calendar}
          history={history}
          params={!this.props.shortcut ? this.props.match.params : {}}
          calendarExport={fetchCalendarExport}
          calendarExportIsFetching={calendarExport}
          shortcut={shortcut}
          />
      </>
    )
  }
}

const mapStateToProps = () => {
  const calendarSelector = makeCalendarSelector()
  const calendarExportSelector = makeCalendarExportSelector()
  return (state, ownProps) => {
    const isAdmin = state.user.isAdmin
    const profile = state.user.profile && new Profile(state.user.profile)
    const shortcut = ownProps.shortcut
    const homepage = state.homepage.list
    const calendar = calendarSelector(state, ownProps)
    const calendarExport = calendarExportSelector(state, ownProps)
    const selectedNav = state.sidebar.selectedNav
    const isContentIntelligence = state.sidebar.isContentIntelligence
    const isCatalogAnalysis = state.sidebar.isCatalogAnalysis
    const isPerformanceAnalysis = state.sidebar.isPerformanceAnalysis
    const isAIInsights = state.sidebar.isAIInsights
    return {
      isAdmin,
      profile,
      homepage,
      shortcut,
      calendar,
      calendarExport,
      selectedNav,
      isContentIntelligence,
      isCatalogAnalysis,
      isPerformanceAnalysis,
      isAIInsights
    }
  }
}

function mapDispatchToProps () {
  return (dispatch) => {
    return {
      fetchHomepage: (groupName) => dispatch(fetchHomepageIfNeeded(groupName)),
      fetchCalendar: (startDate, endDate) => dispatch(fetchCalendarIfNeeded(startDate, endDate)),
      fetchCalendarExport: () => dispatch(fetchCalendarExportIfNeeded()),
      selectedSidebarNav: (nav) => dispatch(setSelectedSidebarNav(nav)),
      logout: () => dispatch(logout())
    }
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(CalendarContainer)